export const SKELETON = {
  width: 120,
  height: 14,
};

export const CLASSNAME = 'text-style-g-em text-neutral-900 flex flex-1 w-full';
